/**
 * Header Layout
 *
 * @file header.js
 */

import $ from "jquery";

const header = (() => {
  const fixedHeader = () => {
    function handleHeaderScroll() {
      var header = document.querySelector('header');
      var headerHeight = header.offsetHeight;
  
      // Header'ın sabitlenip sabitlenmediğini kontrol edin
      if (window.pageYOffset > headerHeight) {
          header.classList.add('sticky');
      } else {
          header.classList.remove('sticky');
      }
    }
    
    // Sayfa yüklendiğinde fonksiyonu çağırın
    document.addEventListener('DOMContentLoaded', function() {
        handleHeaderScroll();
    });
    
    // Sayfa yüklendiğinde veya yenilendiğinde ve scroll edildiğinde fonksiyonu çağırın
    window.addEventListener('scroll', function() {
        handleHeaderScroll();
    });
  };

  
  const headerMenu = () => {
    /* arka plan rengi*/
    var $hoverElement = $("header");
    var $targetElement = $(".o-header");
    
    $hoverElement.hover(
      function() {
        $targetElement.addClass("header-open-menu");
      },
      function() {
        $targetElement.removeClass("header-open-menu");
      }
    );

    

    document.addEventListener("DOMContentLoaded", function() {
      var menuItem1 = document.querySelector(".mega-menu-item-1");
      var menuItem2 = document.querySelector(".mega-menu-item-2");
      var megaMenu = document.querySelector(".mega-menu");
      let isMouseMoving = false;

      // Mouse hareketini takip et
      document.addEventListener('mousemove', function() {
          isMouseMoving = true;
      });

      menuItem1.addEventListener("mouseover", function() {
          if (isMouseMoving) {
              megaMenu.classList.add("item-1-active");
              megaMenu.classList.remove("item-2-active");
          }
      });

      menuItem2.addEventListener("mouseover", function() {
          if (isMouseMoving) {
              megaMenu.classList.add("item-2-active");
              megaMenu.classList.remove("item-1-active");
          }
      });

      menuItem1.addEventListener("mouseout", removeHoverClasses);
      menuItem2.addEventListener("mouseout", removeHoverClasses);

      function removeHoverClasses() {
          megaMenu.classList.remove("item-1-active", "item-2-active");
      }

      const megaContainers = document.querySelectorAll('.mega-menu-container');

      megaContainers.forEach(container => {
          container.addEventListener('mouseleave', function() {
              const activeElements = container.querySelectorAll('.active');
              
              activeElements.forEach(element => {
                  element.classList.remove('active');
              });
          });
      });
    });

    
  document.addEventListener("DOMContentLoaded", function() {
    var menuLinks = document.querySelectorAll(".first-menu a");
    var menuItems = document.querySelectorAll(".second-menu .menu-item");
    var bgBackdrop = document.querySelectorAll(".mega-menu-backdrop-bg");
    menuLinks.forEach(function(link) {
      link.addEventListener("mouseenter", function(event) {
          event.preventDefault();
          menuLinks.forEach(function(link) {
            link.classList.remove("active");
          });
          link.classList.add("active");

          var dataIndex = link.getAttribute("data-index");

          // console.log("Data Index:", dataIndex);
          menuItems.forEach(function(item) {
              item.classList.remove("active");
          });

          var menuItemToShow = document.querySelector(".second-menu .menu-item[data-id='" + dataIndex + "']");
          if (menuItemToShow) {
              menuItemToShow.classList.add("active");
          } else {
              // console.log("MenuItem not found for Data Index:", dataIndex); 
          }
      });
      bgBackdrop.forEach(function(backdrop) {
          backdrop.addEventListener("mouseenter", function(event) {
              menuLinks.forEach(function(link) {
                  link.classList.remove("active");
              });
              menuItems.forEach(function(item) {
                  item.classList.remove("active");
              });
          });
      });
    });

  });
};


  const headerSearch = () => {
    document.addEventListener("DOMContentLoaded", function() {
      document.querySelector(".header-search .inp button").addEventListener("click", function() {
        document.querySelector(".full-search").classList.add("active");
        document.querySelector(".mega-menu-backdrop-bg").classList.add("active");
        setTimeout(function() {
          var searchInput = document.querySelector(".full-search input[type='text']");
          if (searchInput) {
              searchInput.focus();
          }
        }, 500);
      });
    });
    // Event listeners for closing full search
    document.querySelector(".mega-menu-backdrop-bg").addEventListener("click", function() {
      document.querySelector(".full-search").classList.remove("active");
      document.querySelector(".mega-menu-backdrop-bg").classList.remove("active");
    });

    document.querySelector(".full-search-close").addEventListener("click", function() {
      document.querySelector(".full-search").classList.remove("active");
      document.querySelector(".mega-menu-backdrop-bg").classList.remove("active");
    });

    // Event listener for focusing on mobile search input
    document.querySelector(".mobile-search input").addEventListener("focus", function() {
      document.querySelector(".mobile-search-result").classList.add("active");
    });

    // Event listener for closing mobile search
    document.querySelector(".mobile-search-close").addEventListener("click", function() {
      document.querySelector(".mobile-search-result").classList.remove("active");
    });
  };


  const mobileHEader = () => {
    // Event listener for mobile menu hamburger icon
    document.querySelector(".mobile-menu-hamburger").addEventListener("click", function() {
      document.querySelector("html,body").classList.toggle("u-noscroll");
      this.classList.toggle("active");
      document.querySelector(".mobile-menu").classList.toggle("mobile-menu-active");
    });

    // Event listener for main menu item accordion
    document.querySelectorAll(".main-menu-item-accordion .menu-item-title").forEach(function(item) {
      item.addEventListener("click", function() {
        // document.querySelectorAll(".main-menu-item-accordion .menu-item-title").forEach(function(element) {
        //   element.classList.remove("active");
        // });
        this.classList.toggle("active");
        // document.querySelectorAll(".menu-item-content").forEach(function(content) {
        //   content.classList.remove("open-menu");
        // });
        // this.nextElementSibling.classList.add("open-menu");
      });
    });

    // Event listener for menu sub dropdown
    document.querySelectorAll(".menu-item-content .menu-sub-dropdown").forEach(function(item) {
      item.addEventListener("click", function() {
        this.nextElementSibling.classList.add("active");
      });
    });

    document.querySelectorAll(".m-sub-menu-header").forEach(function(item) {
      item.addEventListener("click", function() {
        this.parentNode.classList.remove("active");
      });
    });

    // Event listener for submenu header
    document.querySelectorAll(".m-sub-menu .item-s a").forEach(function(item) {
      item.addEventListener("click", function() {
        document.querySelector("html,body").classList.remove("u-noscroll");
        document.querySelector(".mobile-menu-hamburger").classList.remove("active");
        document.querySelector(".mobile-menu").classList.remove("mobile-menu-active");
      });
    });
  };


  const moveFooterMenu = () => {
    if (window.innerWidth <= 992) {
      const footerBottomMenu = document.querySelector('.footer-bottom .footer-bottom-menu');
      
      if (footerBottomMenu) {
          const footerBottomMenuClone = footerBottomMenu.cloneNode(true);
          const footerMid = document.querySelector('.footer-mid');
          
          if (footerMid) {
              footerMid.appendChild(footerBottomMenuClone);
          }
      }
    }
  };

  const init = () => {
    fixedHeader();
    headerMenu();
    headerSearch();
    mobileHEader();
    moveFooterMenu();
  };

  return {
    init,
  };
})();

export default header;
